import { ErrorIcon } from '@/components/FeedbackChips';
import { Tooltip } from '@/design-system';
import { useColorScheme } from '@/hooks/useColorScheme';
import { cn } from '@/utils/tailwind';

import { HEATMAP_COLORS } from '../utils/getHeatmapStyleFromPercentage';

export const OnlyErrorsChip = ({
  tooltipText,
  numErrors,
  hideBlankScore,
  isHeatmapVisible,
}: {
  tooltipText: string;
  numErrors: number;
  hideBlankScore?: boolean;
  isHeatmapVisible: boolean;
}) => (
  <Tooltip
    title={
      tooltipText ? (
        <div className="max-h-[350px] max-w-[300px] overflow-auto">
          {tooltipText}
        </div>
      ) : null
    }
  >
    <div className="flex items-center gap-2">
      {!hideBlankScore && <BlankScore isHeatmapVisible={isHeatmapVisible} />}
      <ErrorIcon errors={numErrors} />
    </div>
  </Tooltip>
);

export const BlankScore = ({
  isHeatmapVisible,
  shouldShowHover,
  className,
}: {
  isHeatmapVisible?: boolean;
  shouldShowHover?: boolean;
  className?: string;
}) => {
  const { isDarkMode } = useColorScheme();
  const middleColors = HEATMAP_COLORS.middle[isDarkMode ? 'dark' : 'light'];
  return (
    <div
      className={cn(
        'flex min-w-12 justify-center rounded-md py-0.5 font-medium',
        middleColors.text,
        isHeatmapVisible && middleColors.background,
        shouldShowHover &&
          (isHeatmapVisible ? middleColors.hover : 'hover:bg-tertiary'),
        className
      )}
    >
      -
    </div>
  );
};
